import { FASTElement, customElement } from '@microsoft/fast-element';

import template from './template.js'
import styles from './styles.js';

@customElement({
	name: 'site-image',
	template,
	styles
})
export class Image extends FASTElement {}